// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AvatarTsx from "./Avatar.tsx";

let make = AvatarTsx.Avatar;

export {
  make,
}
/* make Not a pure module */
